<template>
  <div class="c-data-export-btn">
    <!-- 第一步：下载表格模板 -->
    <div style="display: flex;flex-direction: row;align-items: center;
                padding-left: 14px;
                background: #F7F8FA;height: 55px;">
      <div style="display: flex;flex:2;">第一步  下载表格模板</div>
      <div style="display: flex;flex:1;">
        <!-- 下载模板按钮 -->
        <c-action v-bind="innerDownloadActionAttrs" />
      </div>
    </div>

    <!-- 第二步：填写后上传表格 -->
    <div style="display: flex;flex-direction: row;align-items: center;
                padding-left: 14px;margin-top: 22px;
                background: #F7F8FA;height: 55px;">
      <div style="display: flex;flex:2;">第二步  填写后上传表格</div>
      <div style="display: flex;flex:1;">
        <!-- 隐藏的文件输入控件 -->
        <input type="file" id="uploadExcel" style="display: none;" ref="fileInput" @change="handleChange" />
        <!-- 选择文件按钮 -->
        <button @click="openFileInput"
         style="background: #409EFF;border: none;
         font-size: 13px;
         width: 104px;height: 27px;border-radius: 2px;color: white;"
        >选择文件</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as XLSX from "xlsx"; // 导入 xlsx 库用于处理 Excel 文件
import { computed, ref, useCurrentAppInstance } from '@zto/zpage';
import { commonOptions } from '@/config' // 导入 Vue 3 的 Composition API

// 获取当前应用实例
const app = useCurrentAppInstance();

// 文件输入控件的引用
const fileInput = ref<HTMLInputElement | null>(null);

// 导出功能（示例）
function exportIn() {
  console.log('exportIn');
}

// 处理文件选择事件
async function handleChange(event: Event) {
  const target = event.target as HTMLInputElement; // 获取事件目标
  const fileList = target.files; // 获取文件列表

  if (fileList && fileList.length > 0) { // 如果有文件被选择
    const file = fileList[0]; // 获取第一个文件
    const reader = new FileReader(); // 创建文件读取器
    reader.readAsBinaryString(file); // 将文件读取为二进制字符串

    // 文件读取完成后处理
    reader.addEventListener("load", async function (e: any) {
      const data = e.target.result; // 获取读取结果
      const wb = XLSX.read(data, { type: 'binary' }); // 读取 Excel 文件
      const sheetName = wb.SheetNames[0]; // 获取第一个工作表的名称
      const sheets = wb.Sheets[sheetName]; // 获取第一个工作表的数据
      const dataList2 = JSON.stringify(XLSX.utils.sheet_to_json(sheets)); // 将工作表数据转换为 JSON 字符串
      const dataList3 = JSON.parse(dataList2); // 将 JSON 字符串解析为数组
      const dispatch = dataList3.map((item:any) =>{

        const companyName = `${item['物流公司'] || ''}`


        return {
          orderId:`${item['下游订单号'] || ''}`,
          logisticsCompanyCode: `${commonOptions.expressCompanyOpts.find(i => i.label.includes(companyName))?.value || ''}`,
          logisticsCompanyName: companyName,
          logisticsNo:`${item['运单号'] || ''}`
        }

        // return {
        //   soNo: `${item['下游订单号'] || ''}`,
        //   companyName,
        //   companyTypeCode:  `${commonOptions.expressCompanyOpts.find(i => i.label.includes(companyName))?.value || ''}`,
        //   logisticsCode: `${item['运单号'] || ''}`,
        //   name: `${item['收货人姓名'] || ''}`,
        //   phone: `${item['联系手机'] || ''}`,
        //   address: `${item['收货地址']}`
        // }
      })

      // 发送请求保存数据
      const res = await app.request({
        api: 'admin/order/batchShipOrder',
        params: {
          orderShipmentList:dispatch
        }
      });

      app.ui.showMessage({
        type: 'success',
        message: `导入成功，数据更新可能有延时，请稍后确认生效`
      })
      console.log('Response:', res); // 打印响应结果
    });
  }

  // 清空文件输入字段，确保下次选择相同文件时也能触发 change 事件
  target.value = null;
}

// 计算属性：下载模板按钮的属性
const innerDownloadActionAttrs = computed(() => {
  return {
    buttonType: 'primary', // 按钮类型
    label: '点击下载模板', // 按钮标签
    actionType: 'download', // 动作类型
    link: 'https://fscdn.zto.com/GetPublicFile/clouddrive/s3:cloudm:clouddrive:57a6f087354d4f92848c96f67f2a2d33.xlsx' // 下载链接
  };
});

// 打开文件选择对话框
const openFileInput = () => {
  if (fileInput.value) {
    fileInput.value.value = null; // 清空文件输入字段
    fileInput.value.click(); // 触发文件选择对话框
  }
};
</script>

<style scoped lang="scss">
/* 你可以根据需要调整样式 */
</style>
